<!--
@Author: MIYONGLE
@Desc: 详情
@Date: 2021-07-28 13时
-->
<template>
  <div>
    <!-- 顶部 -->
    <mMenusNav><span>{{ titleName }}</span></mMenusNav>
    <div class='nav-title'></div>

    <!-- 文章内容 -->
    <div class="article-con-m">
      <span>{{resDataNews.title}}</span>
      <span>{{resDataNews.createDate}}</span>
      <span v-html='resDataNews.content'></span>
    </div>

    <!-- 上下条资讯 -->
    <div class="up-down-news clearfix">
      <!-- 上一条 -->
      <div class="up-down-news-con" @click="jumpPage(resDataUpper.id)" v-if="resDataUpper != null">
        <div>
          <span><i></i>上一篇</span>
          <span>{{resDataUpper.title}}</span>
        </div>
      </div>

      <!-- 下一条 -->
      <div class="up-down-news-con"  @click="jumpPage(resDataLower.id)" v-if="resDataLower != null">
        <div>
          <span><i></i>下一篇</span>
          <span>{{resDataLower.title}}</span>
        </div>
      </div>
    </div>

    <!-- form弹窗 -->
    <mFrom :source='source'></mFrom>

  </div>
</template>

<script type="text/javascript">
import mMenusNav from "../../components/mMenusNav";
import mFrom from "../../components/mFrom";
import {getNewAndInfoDetail} from "../../service/apis";
import {checkNull,changeUrl} from "../../filters/filters";
import {HTTP_CODE} from "../../service/axios_constants";

export default {
  name: "mNews-and-info-detail",
  inject:['reload'], // 引入刷新方法

  components: {
    mMenusNav: mMenusNav,
    mFrom: mFrom,
  },

  data() {
    return {
      titleName: '资讯详情',
      source: 'mzxDetail',
      resDataNews: {},
      resDataUpper: {},
      resDataLower: {},
    }
  },

  watch: {
    resDataNews: function(val){
      this.$nextTick(()=>{
        if(Array.from(document.getElementsByTagName("video")).length != 0 && !checkNull(this.resDataNews.titleVideoPic)){
          document.getElementsByTagName("video")[0].setAttribute('poster', this.resDataNews.titleVideoPic);
        }
      })
    }
  },
 
  created() {
    // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=mzx_zxxq' : '&pageFrom=mzx_zxxq';

    this.xhrGetInfo();
  },

  methods: {

    //xhr--获取详情
    xhrGetInfo(){
      let param = {
        id: this.$route.query.id
      }
      getNewAndInfoDetail(param).then(res=>{
        if (res.statusCode === HTTP_CODE.suc) {
          this.resDataNews = res.data.news;
          this.resDataUpper = res.data.upper;
          this.resDataLower = res.data.lower;
          if(!checkNull(this.resDataNews.titlePic)){
            this.resDataNews.titlePic = changeUrl(this.resDataNews.titlePic);
          }
          if(!checkNull(this.resDataNews.titleVideoPic)){
            this.resDataNews.titleVideoPic = changeUrl(this.resDataNews.titleVideoPic);
          }
        }
      })
    },

    //页面跳转
    jumpPage(id){
      var pathTemp,pathName,pathNameTemp;
      var path = window.location.hash;
      pathTemp = path.substring(path.indexOf("?"));
      
      // 如果是带着?source跳转到详情页面的时候也需要带着相应的值
      if(path.indexOf("source") > 0){
        pathName = path.substring(path.indexOf("&") + 1);
        pathNameTemp = pathName.substring(pathName.indexOf("=") + 1);

        this.$router.push({
          path: '/mNewsAndInfoDetail?id=' + id + '&source=' + pathNameTemp,
        })
      }else{
        this.$router.push({
          path: '/mNewsAndInfoDetail?id=' + id,
        })
      }
      
      // setSession('newsDetailId', id);
      this.reload()  // 刷新页面
    },

  }
}
</script>

<style>
  .article-con-m img, .article-con-m video, .article-con-m audio{
    margin: 30px auto;
    display: block;
    max-width: 100%;
  }

  .article-con-m video{
    /* object-fit: fill; */
    height: 466px;
  }

</style>


<style scoped lang="scss">
  .article-con-detail{
    padding-bottom: 430px;
  }
  .article-con-m{
    margin-top: 40px;
    padding: 0 25px;
    box-sizing: border-box;

    span{
      display: inline-block;
      text-align: left;
      width: 100%;
    }
    span:nth-child(1){
      font-size: 52px;
      color: #100F0F;
      line-height: 75px;
    }

    span:nth-child(2){
      font-size: 36px;
      color: #706F6F;
      margin-top: 20px;
      font-weight: inherit !important;
    }
    span:nth-child(3){
      font-size: 32px;
      color: #403F3F;
      margin-top: 40px;
      line-height: 60px;
    }
  }

  //上下篇
  .up-down-news{
    margin-top: 62px;
    width: 100%;
    padding: 0 24px;
    margin-bottom: 86px;
    .up-down-news-con{
      width: 100%;
      padding: 0 24px;
      box-sizing: border-box;
      border: 2px solid #F4F4F4;
      background: #F9FAFC;
      margin-top: 24px;
      div{
        span{
          width: 100%;
          display: block;
          text-align: justify;
          color: #100F0F;
        }
        span:nth-child(1){
          font-size: 28px;
          height: 98px;
          line-height: 98px;
          border-bottom: 2px solid #E5E5E5;
          i{
            width: 6px;
            height: 24px;
            background: #1985FF;
            border-radius: 16px;
            float: left;
            margin-top: 35px;
            margin-right: 12px;
          }
        }
        span:nth-child(2){
          font-size: 32px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          line-height: 52px;
          max-height: 104px;
          margin-top: 40px;
          margin-bottom: 40px;
        }
      }
    }
  }

  .nav-title{
    background: #100F0F;
    height: 98px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/mobile/mNewsAndInfoDetail.vue